import { render, staticRenderFns } from "./userLabel.vue?vue&type=template&id=0d9be4aa&scoped=true"
import script from "./userLabel.vue?vue&type=script&lang=js"
export * from "./userLabel.vue?vue&type=script&lang=js"
import style0 from "./userLabel.vue?vue&type=style&index=0&id=0d9be4aa&prod&lang=scss&scoped=true"
import style1 from "./userLabel.vue?vue&type=style&index=1&id=0d9be4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9be4aa",
  null
  
)

export default component.exports